module.exports = __webpack_public_path__ + "static/WPForms-b9104c07e6e1c16a229a078154646a75.svg";